import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Spinner from '../layout/Spinner';

const ProtectedRoute = ({
                            component: Component,
                            auth: {isAuthenticatedAdmin, loading, user},
                            ...rest
                        }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticatedAdmin !== null ? (
                <Component {...props} />
            ) : (
                <Redirect to="/admin"/>
            )
        }
    />
);

ProtectedRoute.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps)(ProtectedRoute);
